exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#security-attributes-container {\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.search-icon-container{\r\n    padding: 10px;\r\n    color: #777777;\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/soc-role/create-rol/soc-role.component.css
// module id = ../../../../../src/app/private/soc-role/create-rol/soc-role.component.css
// module chunks = main